<template>
  <div class="items-end">
    <NotFoundData
      text="Dados indisponíveis no momento!"
      v-if="!series.length"
    />
    <!-- <PieChart
        :chart-data="chartData"
        :options="chartOptions"
        v-else
      /> -->
    <div v-else id="chart">
      <apexchart
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import PieChart from "@/components/Chart/PieChart";
import { twColors, twFonts } from "@/services/tailwindConfig";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames } from "@/utils/utils";
import { integer } from "vuelidate/lib/validators";

export default {
  name: "EmpresaCarteiraChart",
  components: { NotFoundData },
  props: {
    values: Array,
    label: Array,
    isValor: Boolean,
  },

  data() {
    return {
      monthNames,
      loadingChart: true,
      notFoundData: false,
      notFoundMessage: "Não há dados suficiente para exibir o resumo",
      dataCompetencia: new Date(),
    };
  },
  computed: {
    series() {
      // console.log(this.label)
      // console.log(this.values[0].data)
      return [
        {
          name: "valor",
          data: this.values[0].data.map((item) => this.formatter(item)),
        },
      ];
    },

    chartOptions() {
      let sum = this.total;
      let isValor = this.isValor;

      let data = {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
            distributed: true,
          },
        },
        dataLabels: {
          offsetY: 3,
          enabled: true,
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true, // habilita a exibição do tooltip
          style: {
            fontSize: "12px", // tamanho da fonte
          },
          y: {
            formatter: function (val) {
              return !isValor ? val + " %" : val;
            },
          },
        },

        yaxis: {
          show: true,
          max: 150,
        },

        xaxis: {
          type: "category",
          categories: this.label,
          labels: {
            formatter: function (value, timestamp, opts) {
              let palavras = value.split(" ");
              let resultado = [];
              let linhaAtual = "";

              palavras.forEach((palavra) => {
                linhaAtual += palavra + " ";
                if (linhaAtual.length > 17) {
                  resultado.push(linhaAtual.trim());
                  linhaAtual = "";
                }
              });

              if (linhaAtual) resultado.push(linhaAtual.trim());

              return resultado;
            },
            show: true,
            hideOverlappingLabels: true,
            // trim: true,
            maxHeight: 160,
            rotate: -30,
            style: {
              fontSize: "15px",
            },
          },
        },

        colors: [
          "#4D88B1",
          "#4D88B1",
          "#4D88B1",
          "#4D88B1",
          "#4D88B1",
          "#4D88B1",
          "#236A81",
          "#002369",
        ],
      };
      data.yaxis.max = this.maximo;
      if (isValor) {
        data.dataLabels.formatter = function (val) {
          return val;
        };

        return data;
      } else {
        data.dataLabels.formatter = function (val) {
          return val + "%";
        };

        return data;
      }
    },
    maximo() {
      let dataArr = this.values[0].data.map((item) => this.formatter(item));
      if (this.isValor) {
        return parseInt(Math.ceil(Math.max(...dataArr) / 10) * 10);
      } else {
        return parseInt(Math.ceil(Math.max(...dataArr) / 10) * 10);
      }
    },
    // chartData() {

    //   }
    // },
    // enviado() {
    //   return this.values[0].data.enviado) || 0;
    // },
    // aguardando() {
    //   return this.values[0].data.aguardando) || 0;
    // },
    // sem_guia() {
    //   return this.values[0].data.sem_guia) || 0;
    // },
    total() {
      let dataArr = [...this.values[0].data];
      let sum = 0;

      for (var i = 0; i < dataArr.length; i++) {
        sum += parseInt(dataArr[i]);
      }
      return sum;
    },
  },
  methods: {
    formatter(value) {
      if (this.isValor) {
        return value;
      } else {
        return ((value * 100) / this.total).toFixed(2);
      }
    },
    setDefaultDataCompetencia() {
      const dataCompetencia = moment().subtract("1", "months").set("date", 1);
      this.dataCompetencia = new Date(dataCompetencia);
    },
  },
  beforeMount() {
    this.setDefaultDataCompetencia();
  },
};
</script>
